import React from "react";
import styled from "styled-components";
import verticalAlignMap from "../../utils/verticalAlignMap";

const SplitInner = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: ${({verticalAlign}) => verticalAlignMap[verticalAlign]};
`;

Split.defaultProps = {
    verticalAlign: "top",
};

export default function Split({children, verticalAlign, ...props}) {
    return (
        <SplitInner verticalAlign={verticalAlign} {...props}>
            {children}
        </SplitInner>
    );
}
